import { Pipe, inject } from '@angular/core';

import { CurrencyService } from '@fantaz/shared/utils';

@Pipe({
  name: 'fzCurrency',
  pure: true,
  standalone: true,
})
export class CurrencyPipe {
  #currencyService = inject(CurrencyService);

  transform(value: number | string, format: 'html' | 'text' = 'text'): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }
    const dollar = this.#currencyService.convertDollar(value);
    return format === 'html'
      ? `<span class="font-bold">${dollar}</span> <span class="text-gray-500 font-normal">USD</span>`
      : `${dollar} USD`;
  }
}
